@use "ui/styles/colors";
@use "ui/styles/sizes";
@use "ui/styles/fonts";

.wrapper {
  color: var(--secondary-text-color);
  font-size: var(--label-font-size, fonts.$mid);
  margin-bottom: sizes.$s4;

  &.required {
    &:after {
      content: "*";
      color: colors.$red;
      margin-left: sizes.$s3;
    }
  }
}